module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("General Atahualpa Túcume paused for a moment as he turned the corner on the trail, catching sight of the valley and the soaring mountains beyond. Though he had been born here in the foothills of the Andes, each time he saw them he was filled with awe. Lush and warm here in the north because of the proximity to the equator, the mountains towered over green plateaus and lakes so pure they looked like the tears of the sun god, crying for his lost people. Trees seemed to explode from solid rock. Water tumbled down in clear streams that glowed with a light stolen from the sun, not merely reflected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A thousand years before, one of the world’s great civilizations had ruled these mountains and their valleys, the nearby jungle, and the exotic desert coast to the west. They built massive temples that rivaled those of Egypt, constructed elaborate forts and luxurious villas, studied the sun with the precision of the Greeks and Arabs, and talked to the gods who ruled the universe. A few of these men were gods themselves, passing among the living so that destiny could be fulfilled. Only the arrival of European diseases they could neither see nor fight brought them down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some saw their decline as the way of the universe, with its endless cycles, its rising and setting sun, its ever-changing moon. Others saw it as the result of grave sins that had to be expiated in the blood of the people, a stain on the soul of the mountains themselves. A few thought it temporary, a mere night in the long day of existence, the passage of a dark moment in an hour of great achievement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("General Atahualpa Túcume was one of the latter. A modern man, he had been educated in the finest schools of Spain and the United States. But it was no accident that General Atahualpa Túcume’s first name was that of a great Inca ruler or that his last recalled a regional capital during the Inca reign. The general was the rarest of rare Peruvians—a modern man wholly of Inca blood, whose ancestors had not been polluted by compromise with the Spanish conquerors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Technically, the word “Inca” referred to the aristocratic family of rulers who presided over the empire of the Four Quarters, called Tahuantinsuyu in Quechua, the empire’s official language. The empire included a large number of tribes of different backgrounds; at its height in 1500, the Great Inca governed a population of 10 million from his capital at Cusco in the Andean mountains. His domain stretched to modern Bolivia and down to what is now Chile, from the Pacific to the headwaters of the Amazonian river. Túcume’s ancestor, according to carefully handed down traditions, had been a great ruler in the north at the time of the Spaniards’ arrival. Sometime after Pizarro beheaded the Inca ruler Atahualpa in 1533, Túcume’s direct ancestor fled the approaching conquistadors and took shelter with an eastern tribe. There the family bided its time, telling stories of past glories and dreaming of future ones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Túcume had been raised on the stories. Long before he attended Madrid and Miami University, he had memorized the oral poem commemorating the legend of his namesake, Atahualpa. The entire epic was a thing of beauty, but especially poignant were the lines of his beheading. Atahualpa predicted that he would return to avenge his people as Inkarri, the messiah of the earth. Túcume knew in his heart that these words were not fiction but the strongest truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But as a thoroughly modern man, Túcume knew better than to rely on stories or even religion for his power. Power came from the ability to destroy, and he alone among the Incas, among the Peruvians, possessed the modern equivalent of the sun god’s arrow: a small nuclear warhead hidden not too far from here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It might be said that obtaining it had been a matter of luck, rather than fate. Certainly the circumstances argued that. The bomb fell almost literally at the general’s feet. But the tangled weave of events that had brought the warhead to him was so improbable that Túcume was convinced his ancestors had taken a hand. The Incas, and all natives of the land, would rise again, and Túcume, selected by luck or fate, was the man who would lead them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He began walking again, turning another corner on the path. The man Túcume had come to meet was standing amid a knot of bodyguards about twenty meters away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. President!” shouted Túcume, greeting Hernando Aznar as he drew close.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Still only a candidate,” said Aznar. “And a distant one at that. With a short week to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A long week,” said Túcume, who knew what it would include.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You take a huge risk meeting me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here? Never. This is not Lima, where spies are everywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A risk for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nonsense. Is it against the law for a candidate to speak to a general? No. Absolutely not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your contributions—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah.” Túcume waved his hand. “You are doing extremely well. Extremely well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The papers all say I won’t finish above third.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was why they had had to meet; Aznar had become defeatist and needed propping up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All of the journalists are on the government’s payroll,” Túcume assured him. “Who else would call the vice president a man of the people? Ramon Ortez, who owns an armor-plated Mercedes and whose wife shops three times a year in Madrid, a man of the people? Victor Imbecile—who votes for a communist anymore?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As was his custom, Túcume mangled the candidate’s name and his political affiliation: Victor Imberbe represented the Peruvian Centrists, and his moderate views were in no way left of center, let alone communist. In the past, this distortion had pleased Aznar, and he would jokingly add something of his own about one of the other candidates, Bartolo Lopez, who really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" a communist. But today Aznar merely frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our polls,” he said. “We have barely twenty percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And climbing,” said Túcume quickly. “It’s the direction that is important. Ortez has lost votes. They will go to you. Imberbe has barely forty percent. You are catching up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“With this many candidates, the lead is insurmountable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not for the first time, Túcume wished that he could have run for the office himself. But the uniform had become a political liability in Peru, thanks to the criminal antics of some who had preceded him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are going in the right direction,” Túcume told his man firmly. “Continue to make your speeches. Do your work. We must all do our work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The general glanced toward the knot of aides standing a respectful distance away. Among them were Aznar’s speechwriter—a mumbling Jew from Argentina who had somehow been gifted with a golden pen—and the candidate’s political adviser. Both were secretly on Túcume’s payroll. He called them over, pretending not to know them very well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Geraldo, how are you?” he said to the speechwriter. “What are the high points of today’s speech?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The poisoners of our country,” said the man, his beaky nose pointed almost straight down. “We must band together to fight them and seize the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There, you see?” exclaimed Túcume. “What stronger argument can you make? The Maoist rebels are trying to steal our country.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“People don’t believe the rebels are a serious threat,” said Aznar glumly. “The cities are especially smug, even after the latest attacks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They will see,” said Túcume.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Aznar stared at him, puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Túcume grabbed the candidate’s arms, bracing him as if he were in the borderlands again, encouraging his men to chase the Ecuadorian scum.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Peru is counting on you. My people—our people—our ancestors, they are watching and helping you. Look around you; look at this—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Túcume turned Aznar 360 degrees, shaking his shoulders as he went.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is our history and our destiny,” Túcume said. “Peru will be a great nation again. The others will stand up and respect us. Brazil, Argentina, the Ecuadorian dogs. Even El Norte, the demons of America, in the end they will respect us. No longer will we be considered the poor rabble of the world. Peru!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Túcume ended his speech by staring into Aznar’s face. The man had Quechua blood in him; his features made it obvious. But the European was there, too, diluting the courage that was necessary for greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will do my best,” said the candidate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your best will inspire the nation,” said Túcume. “Go.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2b330e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954921_ch04.vue
// module id = 78
// module chunks = 0